import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import { useGetApplicationsQuery } from "slices/beautyApp/jobApply";
import { IMAGE_URL } from "network";

function Applications() {
  const naviagte = useNavigate();

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const auth = useSelector((state) => state.auth.auth?.user);

  // const [del] = useDeleteBeauticianQuery();
  const { data, isLoading, refetch } = useGetApplicationsQuery({
    page,
    limit,
    search,
  });

  const col = [
    { display: "Name", key: "name", type: "display" },
    { display: "Email", key: "email", type: "display" },
    { display: "Gender", key: "gender", type: "display" },
    { display: "Mobile", key: "mobileNumber", type: "display" },
    {
      display: "City",
      key: "city_id",
      type: "display",
      render: (row) => <>{row.city_id?.cityName || "-"}</>,
    },
    {
      display: "Resume",
      key: "resume",
      type: "display",
      render: (row) => {
        if (!row.resume) return <span>-</span>;

        const fileUrl = IMAGE_URL + "docs/" + row.resume; // full uploaded resume URL
        const ext = fileUrl.split(".").pop().toLowerCase();

        if (ext === "pdf") {
          return (
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              View PDF
            </a>
          );
        } else if (ext === "doc" || ext === "docx") {
          return (
            <a
              href={`https://docs.google.com/viewer?url=${fileUrl}&embedded=true`}
              target="_blank"
              rel="noopener noreferrer"
            >
              View DOC
            </a>
          );
        } else {
          return (
            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
              Download
            </a>
          );
        }
      },
    },
    {
      display: "Action",
      key: "action",
      type: "display",
      render: (row) => (
        <>
          <button
            onClick={() => handleApprove(row)}
            className="px-3 py-1 bg-green-500 text-white rounded-lg hover:bg-green-600"
          >
            Approve
          </button>
        </>
      ),
    },
  ];

  const canEdit = hasActionAccess(auth, "Beauty App", "Beautician", "view");
  const canDelete = hasActionAccess(auth, "Beauty App", "Beautician", "delete");

  //   if (canEdit || canDelete) {
  //     col.push({
  //       display: "Actions",
  //       key: "edit",
  //       type: "action",
  //       render: (row, onEdit, handleDelete) => (
  //         <>
  //           {canEdit && <Button onClick={() => onView(row)}>View</Button>}
  //           {canDelete && (
  //             <Button onClick={() => handleDelete(row._id)}>Delete</Button>
  //           )}
  //         </>
  //       ),
  //     });
  //   }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onView = (row) => {
    naviagte(`/beauty-app/beauticians/beautician/${row._id}`);
  };

  const handleAdd = () => {
    naviagte("/beauty-app/beauticians/add-beautician");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this beautician?")) {
      // await del(id).unwrap();
      // refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "Beauty App", "Beautician", "add");

  const handleApprove = (row) => {};

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Beautician
        </Button>
      )} */}

      <Tables
        title={"Applications"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onView}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Applications;
